import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { OurServiceModel } from '../models/service.model';


@Injectable({
  providedIn: 'root'
})
export class OurServiceService {
  constructor(private http: HttpClient) { }
  baseUrl = environment.apiKey;
  token = localStorage.getItem("token");
  httpOptions = {
    headers: new HttpHeaders({
      "Authorization": "Bearer " + this.token,
      "Content-Type": "application/json"
    })
  };

  getAll(): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}OurService/GetAll`, this.httpOptions)
      .pipe(
        catchError(error => throwError(() => error))
      );
  }
  
  GetLasted(): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}OurService/GetLasted`, this.httpOptions)
      .pipe(
        catchError(error => throwError(() => error))
      );
  }
  
  getById(id: number): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}OurService/GetById/${id}`, this.httpOptions)
      .pipe(
        catchError(error => throwError(() => error))
      );
  }

}
